import React, {useState, useEffect} from 'react'
import './specificProfile.css';
import firebase from './../../config/fbConfig.js'
import { Link } from 'react-router-dom'
import noProfile from './../assets/noprofile.png'
import noImage from './../assets/noImage.png'
import owner from './../assets/owner.png'
import PrivateAlbum from './../privateAlbum/privateAlbum.js';

const db = firebase.firestore();

function SpecificProfile(props) {

	let [userID, setUserID] = useState(null)
	const [exists, setExists] = useState(true)
	let [profile, setProfile] = useState({})
	const [showPage, setPage] = useState(false)
	let [album, setAlbum] = useState([])
	let [missingAlbum, setMissingAlbum] = useState([])
	const forceUpdate = React.useState()[1].bind(null, {})

	useEffect(() => {
		// If this is your profile so redirect to My profile
		if (props.user!=null) {
			if (props.match.params.profile_id==props.user.uid) {
				props.history.push('/profile');
				setPage(true);
			}
			
		} else {
			setTimeout(() => {
			setUserID(props.match.params.profile_id);
			userID = props.match.params.profile_id;
			db.collection("accounts").doc(userID).get().then((doc) => {
			    if (doc.exists) {
			        setProfile({
			        	nickname: doc.data().nickname,
			        	bio: doc.data().bio,
			        	pic: doc.data().pic!=null ? doc.data().pic : false,
			        	country: doc.data().country,
			        	countryIMG: doc.data().countryIMG !=false ? doc.data().countryIMG : false,
			        	age: doc.data().age!=null ? doc.data().age : false,
			        	gender: doc.data().gender!=null ? doc.data().gender : false,
			        	motto: doc.data().motto!=null ? doc.data().motto : false,
			        	hobbies: doc.data().hobbies!=null ? doc.data().hobbies : false,
			        	favoritefood: doc.data().favoritefood!=null ? doc.data().favoritefood : false,
			        	skype: doc.data().skype!=null ? doc.data().skype : false
			        }) 
			        setPage(true);

		        	if(!props.isPhone.current && document.body.scrollHeight > window.innerHeight) {
				 		document.getElementById('menu').style.right = '25px';
				 	}
			        
			        

			    } else {
			        // doc.data() will be undefined in this case
			        console.log("No such document!");
			        setExists(false);
			        setPage(true);  
			    }
			}).catch(function(error) {
			    console.log("Error getting document:", error);
			    setPage(true);
			});
			}, 600)

			db.collection("album").doc(props.match.params.profile_id).collection("album").get().then((doc) => {		
						console.log(doc);
						for (let i=0; i<doc.docs.length; i++) {
							album = [...album, doc.docs[i].data()];

							if (i==(doc.docs.length-1)) {
								setAlbum(album);
								let albumLength = album.length;
								if (albumLength<12) {
									for (let i=1; i<=(12-albumLength); i++) {
										missingAlbum.push("")
									}
									setMissingAlbum(missingAlbum);
									forceUpdate();
								}
							}
						}
				})
		}
		
	}, [props.user])

	return (
		<div id="specificProfile">
			{showPage &&
				<React.Fragment>

			{(userID!=null && exists) ?
				<React.Fragment>
				<h1>{profile.nickname}'s Profile
				{props.match.params.profile_id=='eZds0J2Z5YVqDkTHbSsqpHDLL4l2' && <img src={owner} id="owner" alt="Owner"/>}
				</h1>

				<div id="rightSideSpecific">
				<span className="attrName" style={{marginTop: '50px'}} alt="Profile Pic"> Profile Picture:</span> {profile.pic!=false ? <img src={profile.pic}></img> : <img src={noProfile}/>}
				</div>

				<div id="leftSideSpecific">
				{(window.innerWidth<1330) && <h3 style={{textAlign: 'center', paddingTop: '40px'}}>Information about {profile.nickname}:</h3>}
				<div className="Field" style={{marginTop: '50px'}}>
				<span className="attrName"> Nickname:</span>
				<span className="attr">{profile.nickname}</span>
				</div>


				<div className="Field">
				<span className="attrName"> Bio:</span>
				<span className="attr">{profile.bio}</span>
				</div>

				<div style={{position: 'relative', display: 'inline-block'}} className="Field">
				<span className="attrName"> Country:</span>
				<span className="attr">{profile.country}</span>
				<img src={profile.countryIMG} style={{position: 'absolute', top: '-10px', width: '50px', height: '50px', marginLeft: '10px'}} alt="Country"/>
				</div>

				{(profile.age) && 
					<div className="Field">
					<span className="attrName"> Age:</span>
					<span className="attr">{profile.age}</span>
					</div> 
				}

				{(profile.gender) && 
					<div className="Field">
					<span className="attrName"> Gender:</span>
					<span className="attr">{profile.gender}</span>
					</div> 
				}

				{(profile.motto) && 
					<div className="Field">
					<span className="attrName"> Motto:</span>
					<span className="attr">{profile.motto}</span>
					</div> 
				}

				{(profile.skype) && 
					<div className="Field">
					<span className="attrName"> Skype:</span>
					<span className="attr">{profile.skype}</span>
					</div> 
				}

				{(profile.hobbies) && 
					<div className="Field">
					<span className="attrName"> Hobbies:</span>
					<span className="attr">{profile.hobbies}</span>
					</div> 
				}

				{(profile.favoritefood) && 
					<div className="Field">
					<span className="attrName"> Favorite food:</span>
					<span className="attr">{profile.favoritefood}</span>
					</div> 
				}

				</div>

				



				<h2>{profile.nickname}'s Album</h2>

				<PrivateAlbum album={album} user={props.user} match={props.match} isPhone={props.isPhone} forceUpdate={forceUpdate} profile={profile} setAlbum={setAlbum} missingAlbum={missingAlbum} setMissingAlbum={setMissingAlbum}/>

				</React.Fragment> 
				:
				<h1>
				User not found, I'm sorry 😢
				</h1>
			}

			</React.Fragment>

			}
		</div>
	)
}

export default SpecificProfile